import {
  NETWORK_ERROR,
  NETWORK_START,
  NETWORK_STOP,
  SIGN_IN,
  SIGN_OUT,
  SIGN_OUT_SOFT
} from "./authTypes";

const initialState = {
  isLogin: false,
  networkRequests: 0,
  identity: null,
  lastError: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case NETWORK_ERROR:
      return { ...state, lastError: action.error, isLogin: false };
    case NETWORK_START:
      return { ...state, networkRequests: state.networkRequests + 1 };
    case NETWORK_STOP:
      return { ...state, networkRequests: state.networkRequests - 1 };
    case SIGN_IN:
      return { ...state, identity: action.identity, isLogin: true };
    case SIGN_OUT:
      return { ...state, identity: null, isLogin: false };
    case SIGN_OUT_SOFT:
      return {...state, identity: null, isLogin: false, networkRequests: 0};
    default:
      return state;
  }
}
